import React, { useEffect, useMemo, useState } from "react";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";
import qs from "qs";
import logo from "assets/img/logo.png";

import useStyles from "./style";
import Header from "components/header";
import { Button, Flex, Text } from "@chakra-ui/react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Footer from "components/footerUser";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, InputAdornment, InputLabel } from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import ErrorOutline from "@mui/icons-material/ErrorOutline";

const API_BASE = "https://api.personatalenta.id";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

const initialParams = {
  username: "",
  email: "",
  password1: "",
  password2: "",
  birthDate: "",
  birthTime: "",
  gender: "", // gunakan "1" untuk Female, "0" untuk Male (string)
};

// Parser sesuai response yang kamu kirimkan
function parseAvailability(res, key /* 'email' | 'username' */) {
  const node = res?.data?.data?.[key];
  const available = Boolean(node?.available);
  const message =
    typeof node?.message === "string"
      ? node.message
      : available
      ? `${key[0].toUpperCase() + key.slice(1)} available`
      : `${key[0].toUpperCase() + key.slice(1)} not available`;
  return { available, message };
}

const Signup = () => {
  const [params, setParams] = useState(initialParams);
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const styles = useStyles();

  // status: 'idle' | 'checking' | 'available' | 'taken' | 'error'
  const [usernameCheck, setUsernameCheck] = useState({
    status: "idle",
    message: "",
  });
  const [emailCheck, setEmailCheck] = useState({ status: "idle", message: "" });

  // OTP Timer State
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [canResend, setCanResend] = useState(false);

  const emailValid = useMemo(() => {
    if (!params.email) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.email);
  }, [params.email]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const onChangeInput = (e) => {
    const { id, value } = e.target;
    const patch = {};

    if (id === "username") {
      patch.name = value;
      patch.username = value;
    } else if (id === "password") {
      patch.password1 = value;
      patch.password2 = value;
    } else if (id === "birthDate") {
      patch.birthDate = value;
    } else if (id === "birthTime") {
      patch.birthTime = value;
    } else if (id === "gender") {
      patch.gender = value; // "1" atau "0"
    } else if (id === "email") {
      patch.email = value;
    } else {
      patch[id] = value;
    }

    setParams((p) => ({ ...p, ...patch }));
  };

  const onChangeOTP = (e) => setOtp(e.target.value);

  const handleRegister = () => {
    axios
      .post(`${API_BASE}/user/register`, qs.stringify({ ...params }), {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        if (res?.data?.message === "Pendaftaran berhasil") {
          setToken(res.data.token);
          setOpen(true);
        }
      })
      .catch((err) => {
        setActive(0);
        setError(
          err?.response?.data?.message ||
            err?.response?.data ||
            "Terjadi kesalahan."
        );
      });
  };

  const handleVerifyOTP = () => {
    const body = { code: otp, email: params.email, token };
    axios
      .post(`${API_BASE}/user/verify_email`, qs.stringify(body), {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        if (
          res?.data?.message === "Email verified successfully. Please login"
        ) {
          window.location.assign("/login");
        } else if (res?.data?.token) {
          localStorage.setItem("token", res.data.token);
          window.location.assign("/dashboard/profile");
        }
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data ||
            "OTP salah atau kedaluwarsa."
        );
      });
  };

  const handleClose = () => setOpen(false);
  const handleOpenOTP = () => {
    setOpen(false);
    setActive(2);
    // Reset timer when opening OTP
    setTimeLeft(120);
    setCanResend(false);
  };

  const handleResendOTP = () => {
    const body = { email: params.email };
    axios
      .post(`${API_BASE}/user/resend_otp`, qs.stringify(body), {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Reset timer
        setTimeLeft(120);
        setCanResend(false);
        // Optional: Show success message
        // setError("OTP has been resent to your email.");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data ||
            "Gagal mengirim ulang OTP."
        );
      });
  };

  // ==== OTP Timer Effect ====
  useEffect(() => {
    if (active !== 2) return;

    if (timeLeft === 0) {
      setCanResend(true);
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [active, timeLeft]);

  // Helper to format time MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // ==== Debounce USERNAME ====
  useEffect(() => {
    if (!params.username || params.username.trim().length < 6) {
      setUsernameCheck({ status: "idle", message: "" });
      return;
    }

    setUsernameCheck({ status: "checking", message: "" });

    const controller = new AbortController();
    const t = setTimeout(() => {
      axios
        .get(`${API_BASE}/user/inquiry/check-availability`, {
          params: { username: params.username.trim() },
          signal: controller.signal,
        })
        .then((res) => {
          const { available, message } = parseAvailability(res, "username");
          setUsernameCheck({
            status: available ? "available" : "taken",
            message,
          });
        })
        .catch((err) => {
          if (controller.signal.aborted) return;
          setUsernameCheck({
            status: "error",
            message: err?.response?.data?.message || "Gagal mengecek username",
          });
        });
    }, 500);

    return () => {
      controller.abort();
      clearTimeout(t);
    };
  }, [params.username]);

  // ==== Debounce EMAIL ====
  useEffect(() => {
    if (!params.email || !emailValid) {
      setEmailCheck({
        status: params.email ? "error" : "idle",
        message: params.email && !emailValid ? "Format email tidak valid" : "",
      });
      return;
    }

    setEmailCheck({ status: "checking", message: "" });

    const controller = new AbortController();
    const t = setTimeout(() => {
      axios
        .get(`${API_BASE}/user/inquiry/check-availability`, {
          params: { email: params.email.trim() },
          signal: controller.signal,
        })
        .then((res) => {
          const { available, message } = parseAvailability(res, "email");
          setEmailCheck({ status: available ? "available" : "taken", message });
        })
        .catch((err) => {
          if (controller.signal.aborted) return;
          setEmailCheck({
            status: "error",
            message: err?.response?.data?.message || "Gagal mengecek email",
          });
        });
    }, 500);

    return () => {
      controller.abort();
      clearTimeout(t);
    };
  }, [params.email, emailValid]);

  const handleNext = () => {
    if (active === 0) {
      if (!params.username) setError("Username is required");
      else if (params.username.length < 6 || params.username.length > 20)
        setError("Username minimal 6 karakter dan maksimal 20 karakter");
      else if (!params.email) setError("Email is required");
      else if (!emailValid) setError("Format email tidak valid");
      else if (!params.password1 || !params.password2)
        setError("Password is Required");
      else if (usernameCheck.status === "taken")
        setError("Username sudah dipakai");
      else if (emailCheck.status === "taken") setError("Email sudah terdaftar");
      else if (
        usernameCheck.status !== "available" ||
        emailCheck.status !== "available"
      )
        setError("Sedang mengecek ketersediaan. Coba lagi sebentar…");
      else {
        setError("");
        setActive(1);
      }
    } else if (active === 1) {
      const birthDate = new Date(params.birthDate);
      const minDate = new Date("1940-01-01");
      const maxDate = new Date("2040-12-31");

      if (!params.birthDate) setError("Birth date is required");
      else if (birthDate < minDate || birthDate > maxDate)
        setError("Birth date must be between 1940 and 2040");
      else if (!params.birthTime) setError("Birth time is required");
      else if (
        params.gender === "" ||
        params.gender === null ||
        params.gender === undefined
      )
        setError("Gender is required");
      else {
        setError("");
        handleRegister();
      }
    } else if (active === 2) {
      if (otp === "") setError("OTP is required");
      else {
        setError("");
        handleVerifyOTP();
      }
    }
  };

  const adornmentByStatus = (status) => {
    if (status === "checking") return <CircularProgress size={18} />;
    if (status === "available") return <CheckCircleOutline fontSize="small" />;
    if (status === "taken" || status === "error")
      return <ErrorOutline fontSize="small" />;
    return null;
  };

  return (
    <>
      <div className={styles.app}>
        <Header />
        <div className={styles.containerListItem}>
          <div className={styles.containerBackground}>
            <div className={styles.containerInput}>
              <div className="list">
                {error && (
                  <Flex bgColor="red" borderRadius={10} px={5} my={5}>
                    <Text color="white">{error}</Text>
                  </Flex>
                )}

                {active === 0 ? (
                  <Flex flexDirection={{ sm: "column", md: "row" }} gap={5}>
                    <Flex flex={1} flexDirection="column">
                      <img src={logo} className={styles.logo} alt="logo" />
                      <h1 style={{ fontSize: 20 }}>Buat akun Persona</h1>
                      <p style={{ fontSize: 16 }}>
                        Silahkan masukkan username, email dan password
                      </p>
                    </Flex>

                    <Flex flex={1} flexDirection="column" gap={5}>
                      <Flex flex={10}>
                        <TextField
                          fullWidth
                          label="Username"
                          id="username"
                          value={params.username}
                          variant="outlined"
                          size="medium"
                          onChange={onChangeInput}
                          inputProps={{ maxLength: 20 }}
                          placeholder="minimal 6 huruf"
                          error={["taken", "error"].includes(
                            usernameCheck.status
                          )}
                          helperText={
                            usernameCheck.status === "idle"
                              ? ""
                              : usernameCheck.status === "checking"
                              ? "Checking username…"
                              : usernameCheck.message
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {adornmentByStatus(usernameCheck.status)}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Flex>

                      <Flex flex={10}>
                        <TextField
                          fullWidth
                          label="Email"
                          id="email"
                          value={params.email}
                          variant="outlined"
                          size="medium"
                          type="email"
                          placeholder="email ini untuk verifikasi account"
                          onChange={onChangeInput}
                          error={
                            !!params.email &&
                            (!emailValid ||
                              ["taken", "error"].includes(emailCheck.status))
                          }
                          helperText={
                            !params.email
                              ? ""
                              : emailCheck.status === "checking"
                              ? "Checking email…"
                              : !emailValid
                              ? "Format email tidak valid"
                              : emailCheck.message
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {adornmentByStatus(emailCheck.status)}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Flex>

                      <Flex flex={10}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel htmlFor="password">Password</InputLabel>
                          <OutlinedInput
                            label="Password"
                            fullWidth
                            id="password"
                            value={params.password1}
                            variant="outlined"
                            size="medium"
                            type={showPassword ? "text" : "password"}
                            placeholder="harus mempunyai huruf dan angka"
                            onChange={onChangeInput}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </Flex>
                    </Flex>
                  </Flex>
                ) : active === 1 ? (
                  <Flex flexDirection={{ sm: "column", md: "row" }} gap={5}>
                    <Flex flex={1} flexDirection="column">
                      <img src={logo} className={styles.logo} alt="logo" />
                      <h1 style={{ fontSize: 20 }}>Informasi Dasar</h1>
                      <p style={{ fontSize: 16, marginBottom: 0 }}>
                        Masukkan tanggal dan jam lahir serta pilih gender anda
                      </p>
                    </Flex>
                    <Flex flex={1} flexDirection="column" gap={5}>
                      <Flex flex={10}>
                        <TextField
                          label="Birth Date"
                          fullWidth
                          id="birthDate"
                          value={params.birthDate}
                          variant="outlined"
                          type="date"
                          size="medium"
                          onChange={onChangeInput}
                          inputProps={{ min: "1940-01-01", max: "2040-12-31" }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Flex>

                      <Flex flex={10}>
                        <TextField
                          label="Birth Time"
                          fullWidth
                          id="birthTime"
                          value={params.birthTime}
                          variant="outlined"
                          type="time"
                          size="medium"
                          onChange={onChangeInput}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Flex>

                      <Flex flex={10}>
                        <RadioGroup
                          row
                          id="gender"
                          onChange={onChangeInput}
                          value={params.gender ?? ""}
                        >
                          <FormControlLabel
                            value={"1"}
                            control={<Radio id="gender" />}
                            label="Female"
                          />
                          <FormControlLabel
                            value={"0"}
                            control={<Radio id="gender" />}
                            label="Male"
                          />
                        </RadioGroup>
                      </Flex>
                    </Flex>
                  </Flex>
                ) : (
                  <Flex flexDirection={{ sm: "column", md: "row" }} gap={5}>
                    <Flex flex={1} flexDirection="column">
                      <img src={logo} className={styles.logo} alt="logo" />
                      <h1 style={{ fontSize: 20 }}>Masukkan OTP</h1>
                      <p style={{ fontSize: 16, marginBottom: 0 }}>
                        Masukkan kode OTP yang ada di email kamu
                      </p>
                    </Flex>
                    <Flex flex={1} flexDirection="column" gap={5}>
                      <Flex flex={10} flexDirection="column">
                        <TextField
                          label="Kode OTP"
                          fullWidth
                          id="otp"
                          value={otp}
                          variant="outlined"
                          size="medium"
                          onChange={onChangeOTP}
                          placeholder="Masukkan kode OTP yang ada di email kamu"
                          InputLabelProps={{ shrink: true }}
                        />
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          mt={2}
                        >
                          {!canResend ? (
                            <Text fontSize="sm" color="gray.500">
                              OTP berlaku {formatTime(timeLeft)}
                            </Text>
                          ) : (
                            <Button
                              size="sm"
                              variant="link"
                              color="blue.500"
                              textDecorationStyle="solid"
                              textDecorationLine="underline"
                              fontWeight="bold"
                              fontStyle="italic"
                              textUnderlineOffset={2}
                              onClick={handleResendOTP}
                            >
                              Kirim Ulang OTP ke email
                            </Button>
                          )}
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                )}
              </div>
            </div>

            <div className={styles.containerButton}>
              <Button
                borderWidth={1}
                bg={"green"}
                color="white"
                fontSize="sm"
                fontWeight="bold"
                borderRadius="5px"
                px="25px"
                py="5px"
                onClick={handleNext}
                isDisabled={false}
              >
                {active === 0 ? "Next" : active === 1 ? "Sign Up" : "Submit"}
              </Button>
            </div>
          </div>
        </div>

        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Terima kasih telah mendaftar
          </DialogTitle>
          <DialogContent dividers>
            <Flex flexDirection="row" wrap="wrap" maxWidth="100%" gap={1}>
              <Text fontWeight="bold">
                Kami telah mengirim link verifikasi dan kode OTP anda ke alamat
                email terdaftar. Silahkan cek email anda!
              </Text>
              <Text fontStyle="italic" fontSize="xs">
                Jika Anda tidak menemukan email verifikasi di kotak masuk,
                silakan periksa folder spam atau promosi.
              </Text>
            </Flex>
          </DialogContent>
          <DialogActions>
            <Button
              borderWidth={1}
              bg={"green"}
              color="white"
              fontSize="sm"
              fontWeight="bold"
              borderRadius="5px"
              px="10px"
              py="5px"
              onClick={handleOpenOTP}
            >
              Masukkan OTP
            </Button>
            <Button
              borderWidth={1}
              bg={"green"}
              color="white"
              fontSize="sm"
              fontWeight="bold"
              borderRadius="5px"
              px="10px"
              py="5px"
              onClick={() => window.location.assign("/login")}
            >
              Login
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </div>
      <Footer />
    </>
  );
};

export default Signup;
